import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ga',
  months: [
    'Eanáir',
    'Feabhra',
    'Márta',
    'Aibreán',
    'Bealtaine',
    'Meitheamh',
    'Iúil',
    'Lúnasa',
    'Meán Fómhair',
    'Deireadh Fómhair',
    'Samhain',
    'Nollaig',
  ],
  monthsShort: ['Ean', 'Feabh', 'Márta', 'Aib', 'Beal', 'Meith', 'Iúil', 'Lún', 'MFómh', 'DFómh', 'Samh', 'Noll'],
  weekdays: ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Sathairn'],
  weekdaysMin: ['D', 'L', 'M', 'C', 'D', 'A', 'S'],
  weekdaysShort: ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd D MMMM, YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM, YYYY, h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd D MMM, YYYY, h:mm A',
    'llll-Y': 'ddd D MMM, h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([MAG]Z)',
    'LLL+to': 'D MMMM, YYYY, HH:mm ([MAG]Z)',
  },
  meridiem: { am: 'r.n.', pm: 'i.n.', AM: 'R.N.', PM: 'I.N.' },
  past: {
    y: {
      one: '%s bhl. ó shin',
      two: '%s bhl. ó shin',
      few: '%s bl. ó shin',
      many: '%s mbl. ó shin',
      other: '%s bl. ó shin',
    },
    M: {
      one: '%s mhí ó shin',
      two: '%s mhí ó shin',
      few: '%s mhí ó shin',
      many: '%s mí ó shin',
      other: '%s mí ó shin',
    },
    w: {
      one: '%s scht. ó shin',
      two: '%s shcht. ó shin',
      few: '%s shcht. ó shin',
      many: '%s scht. ó shin',
      other: '%s scht. ó shin',
    },
    d: { one: '%s lá ó shin', two: '%s lá ó shin', few: '%s lá ó shin', many: '%s lá ó shin', other: '%s lá ó shin' },
    h: {
      one: '%s uair ó shin',
      two: '%s uair ó shin',
      few: '%s huaire ó shin',
      many: '%s n-uaire ó shin',
      other: '%s uair ó shin',
    },
    m: {
      one: '%s nóim. ó shin',
      two: '%s nóim. ó shin',
      few: '%s nóim. ó shin',
      many: '%s nóim. ó shin',
      other: '%s nóim. ó shin',
    },
    s: {
      one: '%s soic. ó shin',
      two: '%s shoic. ó shin',
      few: '%s shoic. ó shin',
      many: '%s soic. ó shin',
      other: '%s soic. ó shin',
    },
  },
  future: {
    y: {
      one: 'i gceann %s bl.',
      two: 'i gceann %s bhl.',
      few: 'i gceann %s bl.',
      many: 'i gceann %s mbl.',
      other: 'i gceann %s bl.',
    },
    M: {
      one: 'i gceann %s míosa',
      two: 'i gceann %s mhí',
      few: 'i gceann %s mhí',
      many: 'i gceann %s mí',
      other: 'i gceann %s mí',
    },
    w: {
      one: 'i gceann %s scht.',
      two: 'i gceann %s shcht.',
      few: 'i gceann %s shcht.',
      many: 'i gceann %s scht.',
      other: 'i gceann %s scht.',
    },
    d: {
      one: 'i gceann %s lá',
      two: 'i gceann %s lá',
      few: 'i gceann %s lá',
      many: 'i gceann %s lá',
      other: 'i gceann %s lá',
    },
    h: {
      one: 'i gceann %s uair',
      two: 'i gceann %s uair',
      few: 'i gceann %s huaire',
      many: 'i gceann %s n-uaire',
      other: 'i gceann %s uair',
    },
    m: {
      one: 'i gceann %s nóim.',
      two: 'i gceann %s nóim.',
      few: 'i gceann %s nóim.',
      many: 'i gceann %s nóim.',
      other: 'i gceann %s nóim.',
    },
    s: {
      one: 'i gceann %s soic.',
      two: 'i gceann %s shoic.',
      few: 'i gceann %s shoic.',
      many: 'i gceann %s soic.',
      other: 'i gceann %s soic.',
    },
  },
  pastLong: {
    y: {
      one: '%s bhliain ó shin',
      two: '%s bhliain ó shin',
      few: '%s bliana ó shin',
      many: '%s mbliana ó shin',
      other: '%s bliain ó shin',
    },
    M: {
      one: '%s mhí ó shin',
      two: '%s mhí ó shin',
      few: '%s mhí ó shin',
      many: '%s mí ó shin',
      other: '%s mí ó shin',
    },
    w: {
      one: '%s seachtain ó shin',
      two: '%s sheachtain ó shin',
      few: '%s seachtaine ó shin',
      many: '%s seachtaine ó shin',
      other: '%s seachtain ó shin',
    },
    d: { one: '%s lá ó shin', two: '%s lá ó shin', few: '%s lá ó shin', many: '%s lá ó shin', other: '%s lá ó shin' },
    h: {
      one: '%s uair an chloig ó shin',
      two: '%s uair an chloig ó shin',
      few: '%s uair an chloig ó shin',
      many: '%s n-uair an chloig ó shin',
      other: '%s uair an chloig ó shin',
    },
    m: {
      one: '%s nóiméad ó shin',
      two: '%s nóiméad ó shin',
      few: '%s nóiméad ó shin',
      many: '%s nóiméad ó shin',
      other: '%s nóiméad ó shin',
    },
    s: {
      one: '%s soicind ó shin',
      two: '%s shoicind ó shin',
      few: '%s shoicind ó shin',
      many: '%s soicind ó shin',
      other: '%s soicind ó shin',
    },
  },
  futureLong: {
    y: {
      one: 'i gceann %s bliana',
      two: 'i gceann %s bhliain',
      few: 'i gceann %s bliana',
      many: 'i gceann %s mbliana',
      other: 'i gceann %s bliain',
    },
    M: {
      one: 'i gceann %s mhí',
      two: 'i gceann %s mhí',
      few: 'i gceann %s mhí',
      many: 'i gceann %s mí',
      other: 'i gceann %s mí',
    },
    w: {
      one: 'i gceann %s seachtaine',
      two: 'i gceann %s sheachtain',
      few: 'i gceann %s seachtaine',
      many: 'i gceann %s seachtaine',
      other: 'i gceann %s seachtain',
    },
    d: {
      one: 'i gceann %s lá',
      two: 'i gceann %s lá',
      few: 'i gceann %s lá',
      many: 'i gceann %s lá',
      other: 'i gceann %s lá',
    },
    h: {
      one: 'i gceann %s uair an chloig',
      two: 'i gceann %s uair an chloig',
      few: 'i gceann %s uair an chloig',
      many: 'i gceann %s n-uair an chloig',
      other: 'i gceann %s uair an chloig',
    },
    m: {
      one: 'i gceann %s nóiméad',
      two: 'i gceann %s nóiméad',
      few: 'i gceann %s nóiméad',
      many: 'i gceann %s nóiméad',
      other: 'i gceann %s nóiméad',
    },
    s: {
      one: 'i gceann %s soicind',
      two: 'i gceann %s shoicind',
      few: 'i gceann %s shoicind',
      many: 'i gceann %s soicind',
      other: 'i gceann %s soicind',
    },
  },
  abbr: {
    y: { one: '%s bhl', two: '%s bhl', few: '%s bl', many: '%s mbl', other: '%s bl' },
    M: { one: '%s mhí', two: '%s mhí', few: '%s mhí', many: '%s mí', other: '%s mí' },
    w: { one: '%s scht', two: '%s scht', few: '%s scht', many: '%s scht', other: '%s scht' },
    d: { one: '%s lá', two: '%s lá', few: '%s lá', many: '%s lá', other: '%s lá' },
    h: { one: '%s u', two: '%s u', few: '%s u', many: '%s u', other: '%s u' },
    m: { one: '%s nóim', two: '%s nóim', few: '%s nóim', many: '%s nóim', other: '%s nóim' },
    s: { one: '%s soic', two: '%s shoic', few: '%s shoic', many: '%s soic', other: '%s soic' },
  },
  full: {
    y: { one: '%s bhliain', two: '%s bhliain', few: '%s bliain', many: '%s mbliain', other: '%s bliana' },
    M: { one: '%s mhí', two: '%s mhí', few: '%s mhí', many: '%s mí', other: '%s mí' },
    w: {
      one: '%s seachtain',
      two: '%s sheachtain',
      few: '%s seachtain',
      many: '%s seachtainí',
      other: '%s seachtaine',
    },
    d: { one: '%s lá', two: '%s lá', few: '%s lá', many: '%s lá', other: '%s lá' },
    h: { one: '%s uair', two: '%s uair', few: '%s uair', many: '%s uaireanta', other: '%s uaire' },
    m: { one: '%s nóiméad', two: '%s nóiméad', few: '%s nóiméad', many: '%s nóiméad', other: '%s nóiméad' },
    s: { one: '%s soicind', two: '%s shoicind', few: '%s shoicind', many: '%s soicind', other: '%s soicindí' },
  },
  justNow: 'Anois',
  yesterday: 'Inné',
  today: 'Inniu',
  tomorrow: 'Amárach',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM, YYYY', end: 'ddd, D MMM, YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM, YYYY, HH:mm', end: 'D MMM, YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM, YYYY, HH:mm', end: 'D MMM, YYYY, HH:mm ([MAG]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([MAG]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([MAG]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([MAG]Z)' },
  },
};
const localeName: LocaleName = 'ga';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'r.n.' : 'R.N.';
    } else {
      return isLowerCase ? 'i.n.' : 'I.N.';
    }
  },
};
